import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-video-play-button',
    templateUrl: './video-play-button.component.html',
    styleUrl: './video-play-button.component.scss',
    standalone: false
})
export class VideoPlayButtonComponent {

  @Input() attachmentName: string;

}
